import ClinicalActivityCombineIcon from 'components/atoms/icons/clinical-activity.svg?react';
import { useTranslation } from 'react-i18next';
import VoiceCallsLogged from 'components/molecules/voice-calls-logged';
import SmsActivityLogged from 'components/molecules/sms-activity-logged';
import ManualClinicalNotesLogged from 'components/molecules/manual-clinical-notes-logged';
import { ModuleType } from 'infrastructure/enums';
import ClinicalNotesLoggedTable from 'components/molecules/clinical-notes-logged';
import { useAppSelector } from 'store';

import s from './styles.module.scss';

import type { DateRange } from 'infrastructure/types';
import type { FC } from 'react';

interface ClinicalActivityAndInterventionProps {
  patientGuid: string;
}

const CombinedClinicalActivityAndInterventions: FC<
  ClinicalActivityAndInterventionProps
> = ({ patientGuid }) => {
  const { t } = useTranslation();
  const dateRange = useAppSelector<DateRange>(
    (state) => state.ccmPatientDetails.dates,
  );

  return (
    <div className={s.wrapper} id="clinical-activity">
      <div className={s['title-wrapper']}>
        <h4 className={s.title} data-cy="clinical-activity-section">
          <ClinicalActivityCombineIcon width={28} height={28} />
          {t('labels.clinicalActivityAndClinicalInterventions')}
        </h4>
        <div className={s.divider} />
      </div>
      <div className={s.body}>
        <VoiceCallsLogged
          patientGuid={patientGuid}
          showTabs
          module={ModuleType.RPM}
          dateRange={dateRange}
        />
        <div className={s.divider} />
        <SmsActivityLogged
          patientGuid={patientGuid}
          showTabs
          module={ModuleType.RPM}
        />
        <div className={s.divider} />
        <ClinicalNotesLoggedTable
          patientGuid={patientGuid}
          showTabs
          module={ModuleType.RPM}
          dateRange={dateRange}
        />
        <div className={s.divider} />
        <ManualClinicalNotesLogged
          patientGuid={patientGuid}
          showTabs
          module={ModuleType.RPM}
        />
      </div>
    </div>
  );
};
export default CombinedClinicalActivityAndInterventions;
